module.exports = __webpack_public_path__ + "img/windowsStep3.7a3438a2.png";